import { QUESTIONNAIRE_EVALUATION as MODULE_PREFIX } from '../constants';
export const QUESTIONNAIRE_EVALUATION_FAILURE = `${MODULE_PREFIX}_FAILURE`;
export const questionnaireEvaluationFailureAction = failureMessage => ({
    type: QUESTIONNAIRE_EVALUATION_FAILURE,
    payload: { failureMessage }
});
//# sourceMappingURL=questionnaireEvaluationFailureAction.js.map